import React from 'react'
import PropTypes from 'prop-types'
import { links, constants, mixpanel } from 'common/helpers'
import { FormattedHTMLMessage } from 'sb-react-intl'
import cx from 'classnames'

import Link from 'components/ui/Link/Link'

import messages from './messages'
import s from './SearchBanner.scss'


const trackClick = () =>
  mixpanel.track(constants.analyticsEvents.searchSuggestionClicked, { placement: 'suggestion banner' })

const SearchBanner = ({ className, gender, onClick, id, role, tabIndex }) => {
  const link = gender === 'male' ? links.subscription.collectionsMen : links.subscription.collectionsWomen

  return (
    <Link
      className={cx(s.banner, className)}
      to={link}
      onClick={() => {
        trackClick()
        onClick()
      }}
      id={id}
      role={role}
      tabIndex={tabIndex}
    >
      <div className={s.info}>
        <FormattedHTMLMessage className={s.title} tag="div" {...messages.title} />
        <FormattedHTMLMessage tag="div" {...messages.text} />
      </div>
    </Link>
  )
}

SearchBanner.propTypes = {
  valueLink: PropTypes.object,
  isMobile: PropTypes.bool,
  isNewMobileViewVisible: PropTypes.bool,
  isNewDesktopViewEnabled: PropTypes.bool,
  onClick: PropTypes.func,
  onTouchStart: PropTypes.func,
}


export default SearchBanner
